export const staticRoutes = {
  careers: 'https://careers.cinemark.com',
  cinemark: 'https://www.cinemark.com',
  cinemarkLinkedIn: 'https://www.linkedin.com/company/Cinemark',
  investorRelations: 'https://ir.cinemark.com',
  loyaltyBadges: 'https://www.cinemark.com/loyalty-badges',
  privateEvents: 'https://www.cinemark.com/private-events',
} as const;
